module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAQAAADZc7J/AAABTklEQVR42u2UMUjDYBBGX0wwRXSoUBERF6kgdHDo5lA3O2RtoRFcHFxSqJOLQxYdHIuLq4uzg4tQBwdXh04ODgVBsCFFSpEGNUKqMUlTk1JwsTflvuS94f4/B+P6J7XGEZlRBDo2W8MAMklPN8U1z6wCSeQ4eAKdGmm3z2BwhUyaGjqJOHiXBlk32cHmAMjSoBul+MbzbjLBGa9sOM/5KEU/DgvcUyf11f2qCMNhE4tTTz9QEY7DITaqLxmgqGBhogTwaW54YiWQKphYVPxhEYMOGmLgDppcBk5fRKODQdEvEFBp0kZD8qS72Oz7vpPQaNNERQhOoV8hck6H9Xh4mGKRB+6YjYt7FWVHofDGiQcvR+E/ihY54JgPCu6bHK1ovKcoUSXFDLc8suzmc1QpReM9heT8PC9cMOkboTDMVtjmnb1R9tA8BZbG+/xP6hONVmccrOd/HQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/favicons/favicon-32x32.png
// module id = 95
// module chunks = 0